import { render, staticRenderFns } from "./UpdateHoldStatusStandaloneModal.vue?vue&type=template&id=6d16e173&"
import script from "./UpdateHoldStatusStandaloneModal.vue?vue&type=script&lang=js&"
export * from "./UpdateHoldStatusStandaloneModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateHoldStatusStandaloneModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports